import gql from "graphql-tag";

export const USERS_QUERY = gql`
  query Users {
    users {
      id
      firstName
      lastName
      email
      role
      isActive
      dateJoined
      lastLogin
      inviter {
        id
        firstName
        lastName
      }
      invitationExpiresInSeconds
      invitationRevokedBy {
        id
        firstName
        lastName
      }
      clientUserServiceAlertRules {
        edges {
          node {
            id
            action
            type
            maxPerToLowerBid
            serviceId
          }
        }
      }
    }
  }
`;
